<template>
    <div class="flex flex-wrap">
        <div class="w-full" v-if="$store.getters.hasSingleProject">
            <Modal :pin-code="user.pin_code"
                   :pin-required="true"
                   :show="showPasswordVisibility"
                   modal-title="Prístupové heslo"
                   :save-button="false"
                   :on-close-click="closePasswordVisibilityWindow">
                <div class="flex flex-col mt-8">
                    <span class="ml-auto mr-auto text-sm font-bold">Heslo:</span>
                    <span class="ml-auto mr-auto bg-gray-200 py-1 px-3 w-40 rounded shadow my-2 text-center">{{ getCredentialPass }}</span>
                </div>
            </Modal>
            <Modal :show="showEditModal" :on-close-click="closeEditModal" :modal-title="editModal ? 'Upraviť prístup' : 'Pridať prístup'"
                   :on-save-click="saveProjectCredentials">
                <label class="relative mt-6">
                    <select v-model="selectedCredential.type" class="pt-2 pb-1 px-1 w-full bg-white"
                            @focusout="() => this.typeFocused = false"
                            @focusin="() => this.typeFocused = true">
                        <option value="admin">Administrácia</option>
                        <option value="db">Databáza</option>
                        <option value="ftp">FTP</option>
                        <option value="smtp">Mail SMTP</option>
                        <option value="sixadmin">Sixadmin</option>
                    </select>
                    <span class="bg-gray-300 relative block w-full" :style="{ height: '2px' }">
                        <span class="w-0 absolute left-0 right-0 mx-auto transition"
                              :class="(typeFocused ? 'w-full ' : '') + 'bg-orange-500'"
                              :style="{ height: '2px' }"></span>
                    </span>
                </label>
                <floating-label label="Hostiteľ" v-model="selectedCredential.host"
                                focus-color="orange"></floating-label>
                <floating-label label="Port" v-model="selectedCredential.port" focus-color="orange"></floating-label>
                <floating-label label="Použivateľ" v-model="selectedCredential.user"
                                focus-color="orange"></floating-label>
                <floating-label label="Databáza" v-show="selectedCredential.type === 'db'"
                                v-model="selectedCredential.database" focus-color="orange"></floating-label>
                <div class="flex">
                    <div class="w-1/2 px-1">
                        <floating-label type="password" label="Heslo" focus-color="orange"
                                        :on-focus-out="() => $forceUpdate()"
                                        v-model="selectedCredential.password"></floating-label>
                    </div>
                    <div class="w-1/2 px-1">
                        <floating-label type="password" label="Heslo Potvrdenie" focus-color="orange"
                                        :on-focus-out="() => $forceUpdate()"
                                        v-model="selectedCredential.confirm_password"></floating-label>
                    </div>
                </div>
                <floating-label label="Poznámka" v-model="selectedCredential.note"
                                focus-color="orange"></floating-label>
            </Modal>
            <Modal :show="showNoteModal" :on-close-click="closeNoteModal" :modal-title="noteModalEdit ? 'Upraviť poznámku' : 'Pridať poznámku'"
                   :on-save-click="saveProjectNote">
                <md-field>
                    <label>Poznámka</label>
                    <md-textarea v-model="selectedNote.note"></md-textarea>
                </md-field>

            </Modal>
            
            <div class="flex flex-wrap w-full bg-white shadow p-6 items-center">
                <div class="mr-4">
                    <div class="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center text-gray-400">
                        <font-awesome icon="folder" class="fa-2x" :class="hasManager ? 'text-'+manager.color : ''"></font-awesome>
                    </div>
                </div>
                <div class="w-2/5">
                    <h2 class="text-xl">{{ project.name }}</h2>
                    <span class="text-sm text-gray-400">{{ project.slogan || "Bez pod-nadpisu" }}</span>
                </div>
                <div class="ml-auto -mx-2">
                    <button v-ripple
                            class="uppercase  rounded hover:shadow-md py-1 px-4 text-sm mx-2"
                            :class="darkMode ? `bg-gray-500 text-gray-800 hover:bg-gray-400` : `bg-gray-200 text-gray-500`">
                        <font-awesome class="text-xs mr-1" icon="pencil-alt"></font-awesome>
                        Upraviť
                    </button>
                    <button v-ripple @click="showNoteWindow"
                            class="uppercase rounded hover:shadow-md py-1 px-4 text-sm mx-2"
                            :class="darkMode ? `bg-teal-800 text-teal-500 hover:bg-teal-900` : `bg-teal-200 text-teal-500`">
                        <font-awesome class="text-xs mr-1" icon="plus"></font-awesome>
                        Poznámku
                    </button>
                    <button v-ripple @click="showEditWindow"
                            class="uppercase rounded hover:shadow-md py-1 px-4 text-sm mx-2"
                            :class="darkMode ? `bg-green-800 text-green-500 hover:bg-green-900` : `bg-green-200 text-green-500`">
                        <font-awesome class="text-xs mr-1" icon="plus"></font-awesome>
                        Prístup
                    </button>
                </div>

                <div class="flex flex-wrap items-center w-full mt-6">
                    <div class="w-1/6 px-4">
                        <span class="mb-1 block text-gray-500">Stav</span>
                        <div class="rounded text-center font-bold text-sm py-1"
                             :class=" darkMode ?  `bg-${project.status.color}-900 text-${project.status.color}-500` :'bg-'+project.status.color+'-100 ' + 'text-'+project.status.color+'-400'">
                            {{ project.status.name }}
                        </div>
                    </div>
                    <div class="w-1/6 px-4">
                        <span class="mb-1 block text-gray-500">Manažér</span>
                        <div class="rounded font-bold text-sm py-1 text-gray-500 bg-gray-100 text-center" 
                        :class="'text-'+(hasManager ? manager.color : 'gray-300')">
                            {{ hasManager ? manager.name : "Bez manažéra"}}
                        </div>
                    </div>
                    <div class="w-1/6 px-4">
                        <span class="block text-gray-500">Členovia</span>
                        <div class="flex">
                            <span class="rounded text-center px-4 font-bold mt-1 text-sm py-1 bg-gray-100 text-gray-500" v-if="project.members.length === 0">Bez členov</span>
                            <span v-for="(member, index) in project.members.slice(0, 4)" 
                                :key="'pmember'+member.id" 
                                class="-mt-1 flex items-center justify-center rounded-full w-10 h-10 border-4 border-white text-xs text-white"
                                :class="'bg-'+member.color+' '+ (index === 0 ? '' : '-ml-2')">
                                <md-tooltip md-direction="bottom">{{ member.name }}</md-tooltip>
                                {{ getInicials(member) }}
                            </span>
                            
                            <span v-if="project.members.length > 4" class="-mt-1 text-white text-xs flex items-center justify-center bg-gray-500 rounded-full w-10 h-10 border-4 border-white -ml-2">
                                +{{ project.members.length - 4 }}
                            </span>
                        </div>
                    </div>

                    <div class="w-1/6 px-4">
                        <span class="mb-1 block text-gray-500">Dátum odovz.</span>
                        <div class="rounded text-center font-bold text-sm py-1 bg-gray-100 text-gray-500">
                            {{ getFormattedDate(project.due_date_timestamp, "DD.MM.YYYY") || "Neurčené" }}
                        </div>
                    </div>
                    <div class="w-2/6 px-4">
                        <span class="mb-1 block text-gray-500">Postup</span>
                        <div class="flex items-center mt-1 w-full">
                            <div class="h-2 w-full bg-gray-200 rounded-full">
                                <div class="h-2 rounded-full" :class="'bg-'+project.status.color+'-300 '" :style="{width: project.progress+'%'}"></div>
                            </div>
                            <span class="ml-2 text-gray-600">{{ project.progress.toFixed(0) }}%</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex -mx-4 flex-wrap mt-6">
                <div class="w-1/2 px-4">
                    <Tabs>

                        <TabItem item-key="prehlad" name="Prehľad" :default-selected="true">
                            <h1 class="mt-2 mb-2 font-light text-xl">Súhrn podľa pozície</h1>
                            <div>
                                <div v-for="(type, index) in ['managers', 'graphics', 'programmers']"
                                    :key="'pos'+index" class="my-2 text-sm text-gray-700">
                                    <h6 class="mt-4 mb-2">{{ titles[type] }}</h6>
                                    <div v-for="member in project[type]" :key="'mem'+member.id"
                                        class="border border-gray-200 my-1 bg-white rounded-full px-4 py-2 flex items-center text-sm text-black">
                                        <span :class="'bg-'+member.color"
                                            class="w-6 h-2 mr-4 rounded-full"></span>
                                        <span class="text-gray-600" :class="member.associated ? '' : 'text-red-400'">{{ member.name }}</span>
                                        <span class="ml-auto font-bold">{{ formatTime(member.totalTime) }} <span class="font-normal text-gray-400">({{ member.totalPart.toFixed(0) }}%)</span></span>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="flex mt-4 items-center text-gray-700 px-4 py-2 text-sm rounded-full border border-gray-200">
                                <span>Celkový čas</span>
                                <span class="ml-auto font-bold">{{ formatTime(project.totalTime) }}</span>
                            </div>
                            
                            <h1 class="mt-6 mb-2 font-light text-xl">Súhrn podľa tagu</h1>
                            <div v-for="(groupTag, index) in project.byTag" :key="'gtag'+index" class="my-2 text-sm text-gray-700">
                                <h6 class="mt-4 mb-2">{{ groupTag.tag.name }}</h6>
                                <div v-for="member in groupTag.users"
                                    :key="'bytagmem'+member.id"
                                    class="border border-gray-200 my-1 bg-white rounded-full px-4 py-2 flex items-center text-sm text-black">
                                    <span :class="'bg-'+member.color"
                                        class="w-6 h-2 mr-4 rounded-full"></span>
                                    <span class="text-gray-600">{{ member.name }}</span>
                                    <span class="ml-auto font-bold">{{ formatTime(member.totalTime) }}</span>
                                </div>
                            </div>
                            <span class="text-gray-500 font-light text-sm" v-if="hasTags === 0">Projekt nemá žiadnu aktivitu s tagom</span>
                        </TabItem>

                        <TabItem item-key="udaje" name="Prístupy">
                            <div class="-mx-3 flex flex-wrap">
                                <div class="empty-state-wrapper" v-if="project.credentials.length === 0">
                                    <div class="empty-state">
                                        <i class="material-icons">lock</i>
                                        <p>Zdá sa, že ešte nemáš žiadny prístup.</p>
                                        <button type="button" v-ripple @click="showEditWindow">Pridať prístup</button>
                                    </div>
                                </div>
                                <div v-if="project.credentials.length > 0" class="w-full px-3">
                                    <span class="my-2 rounded py-0 flex items-center text-gray-400 text-xs">
                                    <span class="w-1/12">Typ</span>
                                    <span class="w-2/12">Host</span>
                                    <span class="w-1/12">Port</span>
                                    <span class="w-3/12">Použivateľ</span>
                                    <span class="w-2/12">Heslo</span>
                                    <span class="w-1/12">Poznámka</span>
                                    <span class="w-2/12 text-right">Akcia</span>
                                </span>
                                    <span v-for="credential in project.credentials"
                                          :key="'cred'+credential.id"
                                          class="border-b border-gray-200 bg-white mb-3 rounded px-0 py-2 flex items-center text-xs">
                                    <span class="w-1/12 text-gray-600">{{ translate_type(credential.c_type) }}</span>
                                    <span class="w-2/12">
                                        <a :class="{ 'text-orange-400': getCredentialHref(credential) }"
                                           target="_blank"
                                           :href="getCredentialHref(credential) || 'javascript:void(0);'">
                                            <span class="flex items-center" v-if="getCredentialHref(credential)"><i class="material-icons text-lg mr-1">link</i> Odkaz</span>
                                            <span v-else>{{ credential.host }}</span>
                                        </a>
                                    </span>
                                    <span class="w-1/12 flex items-center">
                                        {{ credential.port }}
                                        <span class="font-bold text-xs ml-1"
                                              v-if="credential.type === 'smtp' && credential.port === 465">(SSL)</span>
                                        <span class="font-bold text-xs ml-1"
                                              v-if="credential.type === 'smtp' && credential.port === 587">(TLS)</span>
                                    </span>
                                    <span class="w-3/12">{{ credential.user }}</span>
                                    <span class="w-2/12 flex items-center group cursor-pointer" @click="() => openPasswordVisibilityWindow(credential)">
                                        <span v-for="dot in getPasswordDots" :key="dot"
                                              class="w-1 h-1 bg-gray-400 rounded-full mr-1"></span>
                                        <span class="opacity-0 group-hover:opacity-100 ml-1 text-orange-500"><font-awesome
                                            size="xs" icon="eye"></font-awesome></span>
                                    </span>
                                    <label class="w-1/12">
                                        <input type="text" class="text-xs" v-model="credential.note" placeholder="Doplniť">
                                    </label>
                                    <span class="w-2/12 transition cursor-pointer flex">
                                        <button v-ripple @click="(e) => showEditWindow(e, credential)" class="ml-auto uppercase cursor-pointer text-center bg-gray-200 text-gray-500 rounded hover:shadow py-1 px-2 text-sm mr-2">
                                            <font-awesome class="text-xs" icon="pencil-alt"></font-awesome>
                                        </button>
                                        <button v-ripple @click="(e) => deleteCredential(e, credential)" class="uppercase cursor-pointer text-center bg-red-200 text-red-500 rounded hover:shadow py-1 px-2 text-sm">
                                            <font-awesome class="text-xs" :icon="['far', 'trash-alt']"></font-awesome>
                                        </button>
                                    </span>
                                </span>
                                </div>
                            </div>
                        </TabItem>

                        <TabItem item-key="poznamky" name="Poznámky">
                            <div class="flex flex-wrap -mx-3">
                                <div class="empty-state-wrapper" v-if="project.notes.length === 0">
                                    <div class="empty-state">
                                        <i class="material-icons">content_copy</i>
                                        <p>Zdá sa, že ešte nemáš žiadnu poznámku.</p>
                                        <button type="button" v-ripple @click="showNoteWindow">Pridať poznámku</button>
                                    </div>
                                </div>
                                <div v-else class="flex w-full">
                                    <md-button class="md-primary ml-auto mr-auto" type="button" v-ripple @click="showNoteWindow">Pridať poznámku</md-button>
                                </div>
                                <div v-for="note in project.notes" :key="'note'+note.id" class="px-4 w-full h-auto py-4 min-h-32">
                                    <div class="group flex flex-col border rounded border-gray-200 py-3 px-3 h-full">
                                        <span class="flex flex-wrap items-center">
                                            <span class="w-8 h-8 bg-gray-500 rounded-full flex items-center text-xs text-white justify-center">
                                                {{ getInicials(note.user) }}
                                            </span>
                                            <span class="ml-4 text-sm text-gray-500">
                                                {{ getFormattedDate(note.created_at, "DD.M.YYYY [o] k:mm") }}
                                            </span>
                                            <span class="ml-auto">
                                                <span v-ripple class="uppercase cursor-pointer text-center bg-gray-200 text-gray-500 rounded hover:shadow py-1 px-2 text-sm mr-2">
                                                    <font-awesome @click="(e) => showNoteWindow(e, note)"
                                                        icon="pencil-alt"></font-awesome>
                                                </span>
                                                <span v-ripple class="uppercase cursor-pointer text-center bg-red-200 text-red-500 rounded hover:shadow py-1 px-2 text-sm">
                                                    <font-awesome @click="(e) => deleteNote(e, note)"
                                                        :icon="['far', 'trash-alt']"></font-awesome>
                                                </span>
                                            </span>
                                        </span>
                                        
                                        <span class="pt-4 text-gray-700 pb-3 text-sm">
                                            {{ note.note }}
                                        </span>
                                        
                                        <span class="flex items-center pt-3 text-xs border-t border-gray-100 mt-auto" v-if="note.updated_at !== note.created_at">
                                            <span
                                                class="text-xs ml-auto text-gray-400">Upravené: {{ getFormattedDate(note.updated_at, "DD.M.YYYY [o] k:mm") }}</span>
                                        </span>
                                        
                                    </div>
                                </div>
                            </div>
                        </TabItem>
    
                        <TabItem item-key="klient" name="Klient">
                            <div class="w-full">
                                <div class="flex flex-wrap client-info">
                                    <div class="w-1/2">Meno: <span :class="{'empty': !project.client.name}">{{ project.client.name }}</span></div>
                                    <div class="w-1/2">Priezvisko: <span :class="{'empty': !project.client.lastname}">{{ project.client.lastname || '--' }}</span></div>
                                    <div class="w-1/2">ICO: <span :class="{'empty': !project.client.ico}">{{ project.client.ico || '--' }}</span></div>
                                    <div class="w-1/2">DIC: <span :class="{'empty': !project.client.dic}">{{ project.client.dic || '--' }}</span></div>
                                    <div class="w-1/2">Firma: <span :class="{'empty': !project.client.company}">{{ project.client.company || '--' }}</span></div>
                                </div>

                                <md-button :to="{'name': 'clients.detail', params: {clientId: project.client.id}}" class="md-accent">Zobraziť klienta</md-button>
                            </div>
                        </TabItem>
                        
                        <TabItem item-key="nastavenia" name="Nastavenia">
                            
                            <md-field>
<!--                                <p class="my-0 mx-0 text-gray-500 text-xs">Klient:</p>-->
    
                                <multiselect v-model="project.client" :options="clients"
                                     id="ajax" label="full_name" track-by="id"
                                     :selected="project.client.id"
                                     :loading="isLoading"
                                     :clear-on-select="false"
                                     :options-limit="25"
                                     @search-change="fetchClients"
                                     :searchable="true" :close-on-select="true" :show-labels="false"
                                     placeholder="Vyberte jednu z možností"></multiselect>
                            </md-field>
    
                            <md-field>
                                <label for="status_id">Stav</label>
                                <md-select v-model="project.status_id" name="status_id" id="status_id" placeholder="Stav">
                                    <md-option v-for="status in statuses" :key="`stat${status.id}`" :value="status.id" :selected="status.id === project.status_id">{{ status.name }}</md-option>
                                </md-select>
                            </md-field>
                            
                            <md-field>
                                <label>Názov</label>
                                <md-input v-model="project.name"></md-input>
                            </md-field>
    
                            <md-field>
                                <label>Krátky popis</label>
                                <md-textarea v-model="project.slogan" md-autogrow></md-textarea>
                            </md-field>
    
                            <md-field>
                                <label>Popis</label>
                                <md-textarea v-model="project.description" md-autogrow></md-textarea>
                            </md-field>
    
                            <md-field>
                                <label>Doména</label>
                                <md-input v-model="project.domain"></md-input>
                            </md-field>
                            
                            <md-datepicker v-model="project.due_date" :md-model-type="String">
                                <label>Dátum odovzdania</label>
                            </md-datepicker>
                            
                            <md-field>
                                <multiselect v-model="members"
                                             :options="users"
                                             :selected="extractedMembers"
                                             deselect-label="Can't remove this value"
                                             :searchable="false"
                                             :close-on-select="false"
                                             :multiple="true"
                                             :show-labels="false"
                                             :hideSelected="true"
                                             track-by="id" label="name"
                                             placeholder="Vyber členov projektu">
                                    <template slot="singleLabel" slot-scope="{ option }">{{ option.name }} ({{
                                        option.type.name }})
                                    </template>
        
                                    <template slot="tag" slot-scope="{ option, remove }">
                                        <div class="multiselect__tag" v-ripple>
                                            <img v-if="option.image" :src="'/uploads/'+option.image"
                                                 class="w-6 h-6 rounded-full mr-3">
                                            <span v-if="!option.image" :class="'bg-'+option.color"
                                                  class="inicial-box flex items-center justify-center mr-3 text-xs w-6 h-6 text-white rounded-full">{{ getInicials(option) }}</span>
                                            <span class="text-sm">{{ option.name }}</span>
                                            <span class="multiselect__tag-icon">
                                        <i class="material-icons" @click="remove(option)">close</i>
                                    </span>
                                        </div>
                                    </template>
        
                                    <template slot="option" slot-scope="{ option }">
                                <span class="flex items-center">
                                    <img v-if="option.image" :src="'/uploads/'+option.image"
                                         class="w-6 h-6 rounded-full mr-3">
                                    <span v-if="!option.image" :class="'bg-'+option.color"
                                          class="inicial-box flex items-center justify-center mr-3 text-xs w-6 h-6 text-white rounded-full">{{ getInicials(option) }}</span>
                                    <span class="text-sm">{{ option.name }} ({{ option.type.name }})</span>
                                </span>
                                    </template>
                                </multiselect>
                            </md-field>
    
                            <div class="flex">
                                <md-button class="md-primary mt-6 ml-auto" @click="saveProjectData">Uložiť</md-button>
                            </div>
                        </TabItem>

                    </Tabs>
                </div>
                <div class="w-1/2 px-4">
                    <div class="p-4 bg-white shadow-md mt-10">
                        <div class="flex items-center border-b border-gray-200 pb-2 mb-2">
                            <h4 class="text-lg">Úlohy projektu</h4>
                        </div>
                        <div class="text-gray-400 mt-6">
                            <TaskGroup v-for="group in tasks" @submit="submitNewTask" :group="group" :key="'taskgrp'+group.id" />
                            <!-- ///// -->
                            <datepicker @close="() => this.showDatepicker = false" v-if="showDatepicker" :min="today" v-model="selectedDueDate" color="#ed6c08"></datepicker>
                            <form @submit="taskGroupSubmit" class="flex w-full items-center py-2 px-3 border-b border-gray-100 hover:shadow mt-3 rounded-full">
                                <input type="text" v-model="selectedTaskGroupName" class="w-4/6 pl-3 h-full text-black text-sm" placeholder="Nazov zoznamu">
                                <div class="ml-auto w-2/6 flex items-center justify-end">
                                    <div class="py-1 px-2 rounded-full hover:shadow flex items-center overflow-hidden cursor-pointer" v-ripple :class="{'bg-gray-200': selectedDueDate !== '' }">
                                        <div class="flex items-center text-gray-400" :class="{'text-black': selectedDueDate !== ''}" @click="() => this.showDatepicker = true">
                                            <span class="flex rounded-full items-center justify-center w-8 h-8" :class="{'bg-gray-300 text-gray-600': selectedDueDate !== ''}"><i class="material-icons text-lg">calendar_today</i></span>
                                            <span class="text-gray-400 text-xs" :class="{'ml-2': selectedDueDate !== '' }">{{ selectedDueDate }}</span>
                                        </div>
                                        <span @click="discardDueDate" v-if="selectedDueDate !== ''"
                                              class="flex w-4 h-4 rounded-full bg-gray-400 hover:bg-gray-500 text-gray-200 flex items-center justify-center cursor-pointer"
                                              :class="{'ml-2': selectedDueDate !== '' }"><i class="text-xs material-icons">close</i></span>
                                    </div>
                                    <button type="submit" class="ml-3 w-10 h-10 hover:shadow text-orange-500 flex items-center justify-center rounded-full">
                                        <font-awesome icon="arrow-right"></font-awesome>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import { shortifyName, getInicials, formatTotal } from '../../utils';
import Tabs from '../../components/Tabs';
import TabItem from '../../components/TabItem';
import Datepicker from '../../components/Datepicker';
import TaskGroup from './Tasks/TaskGroup';
import moment from 'moment';
import Checkbox from "../../components/Checkbox";
export default {
    name: "ProjectDetail",

    components: {
        Tabs, TabItem, Datepicker, TaskGroup, Checkbox
    },

    data() {
        return {
            titles: {
                'programmers': "Programátori",
                'graphics': "Grafici",
                'managers': "Manažéri"
            },

            // password visibility,
            showPasswordVisibility: false,
            credentialPass: null,

            // credentials crud
            selectedCredential: {},
            editModal: false,
            typeFocused: false,
            showEditModal: false,

            // notes
            selectedNote: {},
            showNoteModal: false,
            noteModalEdit: false,

            // tasks
            selectedTaskGroupName: '',
            selectedDueDate: '',
            showDatepicker: false,
            
            // members
            members: [],
            
            // client selector
            isLoading: false,
            selectedClient: {}
        }
    },

    computed: {
        ...mapState({
            project: state => state.projects.single,
            users: state => state.users.all,
            user: state => state.account.user,
            tasks: state => state.tasks.all,
            statuses: state => state.statuses.all,
            clients: state => state.clients.all,
            darkMode: state => state.darkMode.enabled
        }),

        hasManager() {
            return typeof this.project.managers[0] !== 'undefined' && this.project.associated.indexOf(this.manager.id) !== -1;
        },

        hasTags() {
            return Object.keys(this.project.byTag).length
        },

        manager() {
            return this.project.managers[0];
        },

        getCredentialPass() {
            if (this.credentialPass !== null)
                return atob(this.credentialPass);

            return null;
        },
        getPasswordDots() {
            return Array.from(Array(5).keys());
        },

        // tasks
        today() {
            return moment().format("YYYY-MM-DD");
        },
        
        // members
        extractedMembers() {
            let members = [];

            for (let member of this.project.members) {
                members.push(member);
            }

            return members;
        },
    },

    methods: {
        fetchClients() {
            this.$store.dispatch("fetchClients");
        },
        shortifyName(n) {
            return shortifyName(n);
        },
        getInicials(u) {
            return getInicials(u.name, u.image);
        },
        getFormattedDate(date, format) {
            if(!date) return null;
            return moment.unix(date).utc(true).format(format);
        },
        formatTime(totalSec) {
            return formatTotal(totalSec);
        },
        translate_type(str) {
            if (str === "FILE_CONNECTION")
                return "FTP";
            else if (str === "DATABASE_CONNECTION")
                return "MySQL";
            else if (str === "MAIL_SERVER")
                return "SMTP";
            else if (str === "SIXADMIN_CONNECTION")
                return "Sixadmin";
            else if (str === "SITE_ADMIN_CONNECTION")
                return "Admin.";

            return str;
        },
        getCredentialHref(credential) {
            if (credential.type === "admin" || credential.type === "sixadmin" || credential.host.match(/http:/)) {
                return credential.host;
            }

            return null;
        },

        
        // password visiblity
        closePasswordVisibilityWindow() {
            this.showPasswordVisibility = false;
        },
        openPasswordVisibilityWindow(credential) {
            this.showPasswordVisibility = true;
            this.credentialPass = credential.password;
        },


        // credentials window
        showEditWindow(e, credential = {}) {
            if(credential.length === 0)
                this.editModal = true;
            this.selectedCredential = Object.assign({}, credential);
            this.selectedCredential.password = "";
            this.selectedCredential.confirm_password = "";
            this.selectedCredential.project_id = this.project.id;
            this.showEditModal = true;
        },
        closeEditModal() {
            this.showEditModal = false;
            this.typeFocused = false;
        },


        // credentials crud
        saveProjectCredentials() {
            let promise;

            if (typeof this.selectedCredential.id !== "undefined")
                promise = this.$store.dispatch("updateProjectCredential", this.selectedCredential);
            else
                promise = this.$store.dispatch("newProjectCredential", this.selectedCredential);

            promise.then(r => {
                this.$store.dispatch("fetchSingleProject", this.project.id).then(() => this.selectedCredential = {});
                this.closeEditModal();
            });
        },
        deleteCredential(e, credential) {
            this.$store.dispatch("deleteProjectCredential", credential)
                .then(r => {
                    this.$store.dispatch("fetchSingleProject", this.project.id).then(() => this.selectedCredential = {});
                })
        },

        // notes window
        closeNoteModal() {
            this.showNoteModal = false;
            this.noteModalEdit = false;
        },
        showNoteWindow(e, note = {}) {
            if(Object.keys(note).length > 0)
                this.noteModalEdit = true;
                
            this.selectedNote = Object.assign({}, note);
            this.selectedNote.project_id = this.project.id;
            
            if(typeof this.selectedNote.user_id === 'undefined')
                this.selectedNote.user_id = this.user.id;
            
            this.showNoteModal = true;
        },
        saveProjectNote() {
            let promise;

            if (typeof this.selectedNote.id !== "undefined")
                promise = this.$store.dispatch("updateProjectNote", this.selectedNote);
            else
                promise = this.$store.dispatch("newProjectNote", this.selectedNote);

            promise.then(r => {
                this.$store.dispatch("fetchSingleProject", this.project.id).then(() => this.selectedNote = {});
                this.closeNoteModal();
            });
        },
        deleteNote(e, note) {
            this.$store.dispatch("deleteProjectNote", note)
                .then(r => {
                    this.$store.dispatch("fetchSingleProject", this.project.id).then(() => this.selectedCredential = {});
                })
        },


        // tasks
        taskGroupSubmit(e) {
            e.preventDefault();
            this.$store.dispatch("newTaskGroup", {
                name: this.selectedTaskGroupName,
                due_date: this.selectedDueDate,
                project_id: this.project.id
            }).then(() => {
                this.selectedTaskGroupName = '';
                this.selectedDueDate = '';
                this.$store.dispatch("fetchTasks", {project_id: this.project.id});
            })
        },
        
        discardDueDate() {
            this.selectedDueDate = '';
        },
        
        submitNewTask(e) {
            this.$store.dispatch("fetchTasks", {project_id: this.project.id}).then(() => {
                this.$store.dispatch("fetchSingleProject", this.project.id)
            });
        },

        // project settings
        saveProjectData() {
            this.$store.dispatch("projectUpdate", {
                data: {
                    ...this.project,
                    members: this.members,
                },
                id: this.project.id
            });
        },

        saveProject(inputName, inputValue) {
            let data = {};

            data[inputName] = inputValue;
            this.$store.dispatch("projectUpdate", {
                id: this.project.id,
                data
            });

            console.log(`${inputName} was saved as ${inputValue}!`);
        },

        valueChanged(selectedOption, id) {
            // console.log(values);
            // let valued = Object.keys(values);
            // this.saveProject(selectName, valued);
            let extractedMember = [];

            for(let mem of this.members) {
                extractedMember.push(mem.id);
            }

            this.saveProject("members", extractedMember);
        },
        
    },
    
    beforeMount() {
        this.fetchClients()
    },

    mounted() {
        this.$store.dispatch("fetchSingleProject", this.$route.params.projectId)
            .then(r => {
                this.members = this.extractedMembers;
                this.$store.dispatch("fetchTasks", {project_id: this.project.id});
            });
        this.$store.dispatch("fetchUsers");
        this.$store.dispatch("fetchStatuses");
        
        if(this.$store.getters.hasSingleProject) {
            this.members = this.extractedMembers;
        }
    },

    beforeDestroy() {
        this.$store.commit("clearSingleProject");
        this.$store.commit("clearTasks");
    }
}
</script>

<style lang="scss">
    .empty-state-wrapper {
        @apply px-4 w-full mb-2 py-4;
    }
    .empty-state {
        @apply flex flex-col items-center justify-center text-gray-400 rounded pt-4 px-3 h-full;
        
        button {
            @apply text-sm rounded bg-orange-500 text-white py-2 px-4 mt-4 uppercase font-medium;
            &:hover{
                @apply bg-orange-400;
            }
        }
       
        p {
            @apply mt-4;
        }
        
        i {
            font-size: 5rem;
            @apply text-gray-200;
        }
    }
    .client-info {
        @apply -mx-3;
        &>div {
            @apply pb-4 px-3 flex;
            span {
                @apply ml-auto text-gray-600;
                &.empty {
                    @apply text-gray-300;
                }
            }
        }
    }
</style>